import React from 'react';

class FbPage extends React.Component {
  componentDidMount() {
    if (!window.FB) {
      throw Error('FB SDK not loaded');
    }

    FB.XFBML.parse(this.root.parentNode);
  }

  render() {
    return (
      <div className="fb-page"
        ref={root => this.root = root}
        data-href="https://www.facebook.com/Stacjaborszcz"
        data-tabs="timeline"
        data-small-header="true"
        data-width="320"
        data-height="600"
        data-hide-cover="false"
        data-show-facepile="false" />
    );
  }
}

export default FbPage;



// WEBPACK FOOTER //
// ./src/components/common/Facebook/FbPage.js